'use client';

import { useNProgress } from '@tanem/react-nprogress';
import React from 'react';

import * as S from './TopProgressBar.styles';

type TopProgressBarProps = {
  isAnimating: boolean;
};

export const TopProgressBar: React.FC<TopProgressBarProps> = ({
  isAnimating
}) => {
  const { animationDuration, isFinished, progress } = useNProgress({
    isAnimating,
    minimum: 0.08,
    incrementDuration: 300,
    animationDuration: 200
  });

  return (
    <S.Container
      $isFinished={isFinished}
      $animationDuration={animationDuration}
      aria-hidden
    >
      <S.Bar $progress={progress} $animationDuration={animationDuration} />
      <S.Glow $progress={progress} $animationDuration={animationDuration} />
    </S.Container>
  );
};
